export { NumberMapMutator, stateMutator } from './ifn'
export type { TimeStateMutatorInput, NumberMapMutatorProps } from './ifn'
